export const isYouTubeChannelLink = (link: string) => {
    // Hopefully it catches anything other than individual videos since those are automatically converted to safeyt videos
    return !!link.match(
      /^(https?:\/\/)?(www\.)?youtube\.com\/(channel\/[A-Za-z0-9_-]+|c\/[A-Za-z0-9_-]+|user\/[A-Za-z0-9_-]+|playlist\?list=[A-Za-z0-9_-]+|@?[A-Za-z0-9_-]+)$/,
    );
  };